import React from 'react';
import { CircularProgress } from '@material-ui/core';

export const Loader = ({ ...other }) => (
    <CircularProgress disableShrink color="primary" {...other} />
);
